<div class="headerparam boc-page-header">
    <div class="btnsaveparam ui-btn ui-btn--primary ui-btn--sm ui-btn--auto">
      <i class="fas fa-save"></i>&nbsp; Sauvegarder
    </div>
    <div class="blocmodifuser"></div>
</div>
<div class="contblocparam">
  <div class="blocparam ui-card">
    <div class="hbparam"><i class="fa-duotone fa-light fa-key icduotone"></i> &nbsp;Données de connexion</div>
    <div class="ui-card__body">
      <div class="liforparam ui-form-group">
        <div class="labelparam labp1 ui-form-label">
        </div>
        <div type="text" class="inparam inparamoff" id="inidentifiant"></div>
      </div>
      <div class="liforparam ui-form-group">
        <div class="labelparam labp2 ui-form-label">
        </div>
        <div type="text" class="inparam inparamoff" id="inpassword">
          **********
        </div>
        <div class="btneditpass ui-btn ui-btn--secondary ui-btn--xs ui-btn--auto" role="button" tabindex="0" aria-label="Modifier le mot de passe"> &nbsp;<i class="fas fa-edit" aria-hidden="true"></i><span class="btnlabel">
          Modifier
        </span></div>
      </div>
    </div>
  </div>
  <div class="blocparam ui-card">
    <div class="hbparam"><i class="fa-duotone fa-light fa-rotate icduotone"></i> &nbsp;Synchroniser des comptes</div>
    <div class="ui-card__body">
      <div class="liforparam ui-form-group">
        <div class="labelparam labp3 ui-form-label">
        </div>
        <div type="text" class="inparam inparamoff" id="insynchrocode">
          Entrez le code pour lier un compte Wilout existant
        </div>
      </div>
    </div>
  </div>
  <div class="blocparam ui-card">
    <div class="hbparam"><i class="fa-duotone fa-light fa-paintbrush icduotone"></i> &nbsp;Personnaliser mon espace</div>
    <div class="ui-card__body">
      <div class="liforparam ui-form-group">
        <div class="labelparam ui-form-label">
          Dark mode <span class="infolabdark">- version bêta</span> :
        </div>
        <label class="ui-switch labdark-wrap">
          <input type="checkbox" id="indark">
          <span class="labdark">
            &nbsp; &nbsp; <div class="bardark"><span class="circledark"></span></div>
          </span>
        </label>
      </div>
      <div class="liforparam ui-form-group">
        <div class="labelparam ui-form-label">
          Contrast mode <span class="infolabcontrast"></span> :
        </div>
        <label class="ui-switch labcontrast-wrap">
          <input type="checkbox" id="incontrast">
          <span class="labcontrast">
            &nbsp; &nbsp; <div class="barcontrast"><span class="circlecontrast"></span></div>
          </span>
        </label>
      </div>
      <div class="liforparam ui-form-group">
        <div class="labelparam ui-form-label">
          Langue :
        </div>
        <div class="speakbox">
          <div class="listSpeack">
            <a href="#Weglot-fr" class="itSpeack" id="itsp1">
              <img src="./assets/img/france.png" class="imgSpeack"> &nbsp;FR
            </a>
            <a href="#Weglot-en" class="itSpeack" id="itsp2">
              <img src="./assets/img/royaume-uni.png" class="imgSpeack"> &nbsp;EN
            </a>
            <a href="#Weglot-es" class="itSpeack" id="itsp3">
              <img src="./assets/img/espagne.png" class="imgSpeack"> &nbsp;ES
            </a>
          </div>
          <div class="iclistSpeack">
            <i class="far fa-chevron-down"></i>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="blocparam ui-card" style="height:140px;">
    <div class="hbparam"><i class="fa-duotone fa-light fa-share-from-square icduotone"></i> &nbsp;Partager Wilout CONTROL</div>
    <div class="btnshare shareweb ui-btn ui-btn--secondary ui-btn--xs ui-btn--auto">
      <i class="fas fa-link"></i><span class="respdis1"> &nbsp;Copier lien</span>
    </div>
    <a href="mailto:?subject=Wilout%20CONTROL&body=Gardez%20le%20contrôle%20sur%20vos%20entrées%20avec%20Wilout%20CONTROL%20!%20Créez%20un%20compte%20gratuitement%20sur%20:%20https://wilout.com/.">
    <div class="btnshare sharemail ui-btn ui-btn--secondary ui-btn--icon ui-btn--xs">
        <i class="fas fa-paper-plane"></i>
      </div>
    </a>
    <div class="btnshare sharefb ui-btn ui-btn--secondary ui-btn--icon ui-btn--xs">
      <i class="fab fa-facebook-f"></i>
      <iframe src="https://www.facebook.com/plugins/share_button.php?href=https%3A%2F%2Ffr-fr.facebook.com%2FWilout.fr%2F&layout=button&size=large&width=93&height=28&appId" width="100%" style="border:none;overflow:hidden;margin-top:-3px;transform:scale(1.0,1.6);opacity:0.0;" scrolling="no" frameborder="0" allowTransparency="true" allow="encrypted-media"></iframe>
    </div>
    <a class="twitter-share-button"href="https://twitter.com/intent/tweet?text=Gardez%20le%20contrôle%20sur%20vos%20entrées%20avec%20Wilout%20CONTROL%20!%20Créez%20un%20compte%20gratuitement%20sur%20:%20https://wilout.com/."data-size="large"target="_blank">
      <div class="btnshare sharetwitter ui-btn ui-btn--secondary ui-btn--icon ui-btn--xs">
        <i class="fab fa-twitter"></i>
      </div>
    </a>
    <a href="https://www.instagram.com/wilout/"target="_blank">
      <div class="btnshare shareinsta ui-btn ui-btn--secondary ui-btn--icon ui-btn--xs">
        <i class="fab fa-instagram"></i>
      </div>
    </a>
  </div>
  <div class="blocparam ui-card" style="margin-bottom:300px;">
    <div class="hbparam"><i class="fa-duotone fa-light fa-circle-info icduotone"></i> &nbsp;Informations logiciel</div>
    <div class="ui-card__body">
      <div class="txtparam">
        Date de création du compte : <span class="brtxtparam"><br></span><span class="datecrea"></span>
        <br><span class="brtxtparam"><br></span>
        Mémoire en cache : <span class="storageSize"></span> &nbsp;<span class="brtxtparam"><br></span>
        <br><br>
        <span class="txtparam-version">
        Version du logiciel : 1.1.4  &nbsp;-&nbsp;  <span class="brtxtparam"><br></span>Dernière mise à jour : <span class="brtxtparam"><br></span>28/01/2026
        <br><span class="brtxtparam"><br></span>
        Copyright ©Wilout 2026  &nbsp;-&nbsp;  <span class="brtxtparam"><br></span>Tous droits réservés
        </span>
      </div>
    </div>
  </div>
</div>
<div class="fdpopedit ui-confirm__backdrop">
</div>
<div class="blocedit popChangePass ui-confirm__dialog">
  <div class="headedit ui-confirm__header">
    <span class="ui-confirm__title"><i class="fad fa-pen"></i> &nbsp; Modifier le mot de passe</span>
    <span class="closepopChangePass ui-modal__close"><i class="far fa-times"></i></span>
  </div>
  <div class="bodChangePass ui-confirm__body">
    <div class="labcpass ui-form-label">Mot de passe actuel</div>
    <input type="text" class="incpass oldpass" placeholder="">
    <div class="labcpass ui-form-label">Nouveau mot de passe</div>
    <input type="text" class="incpass newpass" placeholder="6 caractères minimum">
    <div class="texterrorpass ui-form-error">
    </div>
  </div>
  <div class="ui-confirm__footer">
    <div class="btnvalidpass btnvalidpassoff ui-btn ui-btn--primary ui-btn--block">
      Confirmer
    </div>
  </div>
</div>